module.exports = __webpack_public_path__ + "img/coins-4.37b074d0.png";